
const contactFormChatButton = () => {

	const chatInput = document.querySelector('input[value="chat"]')

	console.log('chat input', chatInput)

  if (!chatInput) return false

  chatInput.addEventListener('click', function(e) {

		let icons = document.querySelectorAll('.gnattaChat button')
		for (const icon of icons) {
			if ( !icon.classList.contains('hidden') ) {
				icon.click()
			}
		}
  })
}

export default contactFormChatButton